module.exports = __webpack_public_path__ + "img/comands-history.4f2f3a37.svg";